import { Box, Button, styled } from '@mui/material';

export const SuggestionsWrapper = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  flexWrap: 'wrap',
  gap: theme.spacing(2),

  [theme.breakpoints.down('md')]: {
    marginTop: theme.spacing(-2),
  },

  [theme.breakpoints.up('md')]: {
    marginTop: theme.spacing(-2.5),
    marginBottom: theme.spacing(-0.5),
  },
}));

export const SuggestionButton = styled(Button)(({ theme }) => ({
  fontSize: theme.typography.caption.fontSize,
  fontWeight: theme.typography.caption.fontWeight,
  borderRadius: 4,
  borderColor: theme.palette.grey[400],
  color: theme.palette.grey[800],
  backgroundColor: theme.palette.grey[100],
  padding: theme.spacing(1),
  height: theme.spacing(3.5),

  ':hover': {
    borderColor: theme.palette.green[400],
    backgroundColor: theme.palette.green[100],
  },
}));
